/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import { createGetPromptCatalogueService } from '../../../../common/prompt/createPromptV2Services';
import * as constants from '../../constants/AgenticServiceConstants';
import { PROMPT_MANAGEMENT_LANG_KEYS } from '../../constants/AgenticPromptMgmtConstants';

export default createGetPromptCatalogueService({
  eventName: constants.GET_PROMPT_CATALOGUE,
  statusKey: 'GetPromptCatalogueServiceStatus',
  storeName: 'agenticPromptModel',
  errorLangKey: PROMPT_MANAGEMENT_LANG_KEYS.ERROR_CATALOGUE,
  errorEvent: constants.GET_PROMPT_CATALOGUE_ERROR
});
